import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { label: '首页', href: '#hero' },
    { label: '专题合集', href: '#index' },
    { label: '本站特色', href: '#features' },
    { label: '焦点专题', href: '#carousel' },
    { label: '移动观看', href: '#app' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a
            href="#hero"
            className="flex items-center gap-2 text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer"
          >
            <span className="font-heading text-xl md:text-2xl font-bold tracking-wide whitespace-nowrap">
              羞羞动漫
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <a
            href="#index"
            className="hidden md:inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line text-base"></i>
            开始观看
          </a>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#index"
              onClick={() => setMobileOpen(false)}
              className="mt-2 flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-5 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-base"></i>
              开始观看
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}